import * as PIXI from 'pixi.js';

export default class RoomContainer extends PIXI.Container {
    constructor(room) {
        super();
        this.room = room;

        const roomCardBg = new PIXI.Sprite(PIXI.Assets.get('roomCardBg'));
        roomCardBg.label = 'roomCardBg';
        roomCardBg.x = 0;
        roomCardBg.y = 0;
        this.addChild(roomCardBg);

        const textMask = new PIXI.Graphics();
        textMask.rect(0, 0, 620, 100);
        textMask.fill('white');
        textMask.x = 200;
        textMask.y = 30;
        this.addChild(textMask);

        const roomNameText = new PIXI.Text({
            text: this.room.name,
            style: {
                fontSize: 50,
                fontWeight: '700',
                fontFamily: 'Open Sans',
                fill: '#362107',
            }
        });
        roomNameText.label = 'roomNameText';
        roomNameText.x = 200;
        roomNameText.y = 115;
        roomNameText.anchor.set(0, 1);
        roomNameText.mask = textMask;
        this.addChild(roomNameText);

        const brownInfoBar = new PIXI.Sprite(PIXI.Assets.get('roomCardBrownInfoBar'));
        brownInfoBar.label = 'roomCardBrownInfoBar';
        brownInfoBar.x = 23;
        brownInfoBar.y = 120;
        this.addChild(brownInfoBar);

        const infoText = new PIXI.Text({
            text: `Players: ${this.room.users.map(user => user.username).join(', ')}`,
            style: {
                fontSize: 34,
                fontWeight: '400',
                fontFamily: 'Open Sans',
                fill: '#ddb46b',
            }
        });
        infoText.label = 'infoText';
        infoText.x = 200;
        infoText.y = 125;
        this.addChild(infoText);

        const stateText = new PIXI.Text({
            text: this.room.users.length === 1 ? 'Waiting...' : 'In Match',
            style: {
                fontSize: 34,
                fontWeight: '400',
                fontFamily: 'Open Sans',
                fill: '#ddb46b',
            }
        });
        stateText.label = 'stateText';
        stateText.x = 660;
        stateText.y = 125;
        this.addChild(stateText);

        const waitingState = new PIXI.Sprite(PIXI.Assets.get('roomCardWaitingState'));
        waitingState.label = 'roomCardWaitingState';
        waitingState.x = 28;
        waitingState.y = 33;
        waitingState.visible = this.room.users.length === 1;
        this.addChild(waitingState);

        const inMatchState = new PIXI.Sprite(PIXI.Assets.get('roomCardInMatchState'));
        inMatchState.label = 'roomCardInMatchState';
        inMatchState.x = 28;
        inMatchState.y = 33;
        inMatchState.visible = this.room.users.length === 2;
        this.addChild(inMatchState);

        // const noPlayer1 = new PIXI.Sprite(PIXI.Assets.get('roomCardNoPlayer'));
        // noPlayer1.label = 'roomCardNoPlayer1';
        // noPlayer1.x = 535;
        // noPlayer1.y = 113;
        // noPlayer1.anchor.set(0, 1);
        // this.addChild(noPlayer1);

        const noPlayer2 = new PIXI.Sprite(PIXI.Assets.get('roomCardNoPlayer'));
        noPlayer2.label = 'roomCardNoPlayer2';
        noPlayer2.x = 775;
        noPlayer2.y = 64;
        noPlayer2.anchor.set(0, 1);
        noPlayer2.visible = this.room.users.length === 1;
        this.addChild(noPlayer2);

        const yesPlayer1 = new PIXI.Sprite(PIXI.Assets.get('roomCardYesPlayer'));
        yesPlayer1.label = 'roomCardYesPlayer1';
        yesPlayer1.x = 735;
        yesPlayer1.y = 64;
        yesPlayer1.anchor.set(0, 1);
        this.addChild(yesPlayer1);

        const yesPlayer2 = new PIXI.Sprite(PIXI.Assets.get('roomCardYesPlayer'));
        yesPlayer2.label = 'roomCardYesPlayer2';
        yesPlayer2.x = 775;
        yesPlayer2.y = 64;
        yesPlayer2.anchor.set(0, 1);
        yesPlayer2.visible = this.room.users.length === 2;
        this.addChild(yesPlayer2);
    }
}